module.exports = __webpack_public_path__ + "static/img/44-2.869e457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/44-2.jpg
// module id = 1Ren
// module chunks = 0